import type { DashboardResponse } from '@ekorank/shared'

interface Props {
  brands: DashboardResponse['brands']
  selectedBrandId: string | null
  onSelect: (id: string) => void
  onAdd: () => void
  onSettings: (id: string) => void
  canAddBrand: boolean
  onRunNow: () => void
  triggerLoading: boolean
  creditsBalance: number
  canTrigger: boolean
}

export function BrandHeader({
  brands, selectedBrandId, onSelect, onAdd, onSettings,
  canAddBrand, onRunNow, triggerLoading, creditsBalance, canTrigger,
}: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2 mb-8">
      {brands.map((brand) => (
        <div key={brand.id} className="relative flex items-center group shrink-0">
          <button
            onClick={() => onSelect(brand.id)}
            className={`pl-4 pr-11 py-2.5 rounded-lg border text-sm font-medium whitespace-nowrap transition-all ${
              selectedBrandId === brand.id
                ? 'border-primary/50 bg-primary/10 text-primary'
                : 'border-outline-variant/20 text-on-surface-variant hover:border-outline-variant/40'
            }`}
          >
            {brand.name}
          </button>
          <button
            onClick={(e) => { e.stopPropagation(); onSettings(brand.id) }}
            title="Brand settings"
            className="absolute right-0.5 p-2 rounded-lg text-outline/60 hover:text-on-surface-variant transition-colors touch-manipulation"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
          </button>
        </div>
      ))}
      <div className="w-full sm:hidden" />
      <div className="flex items-center gap-2 sm:ml-auto">
        {canAddBrand && (
          <button
            onClick={onAdd}
            className="px-4 py-2.5 rounded-lg border border-outline-variant/20 text-on-surface-variant hover:border-outline-variant/40 hover:text-white transition-colors text-sm whitespace-nowrap"
          >
            + Add Brand
          </button>
        )}
        {canTrigger && selectedBrandId && (
          <div className="flex items-center gap-2">
            <span className="text-xs font-mono text-outline">{creditsBalance} cr</span>
            <button
              onClick={onRunNow}
              disabled={triggerLoading}
              className="px-4 py-2.5 rounded-lg border border-secondary/30 bg-secondary/10 text-secondary text-sm font-medium hover:bg-secondary/20 transition-colors disabled:opacity-50 whitespace-nowrap"
            >
              {triggerLoading ? 'Queuing…' : '▶ Run Now'}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
